import { Instance } from "mobx-state-tree";
import { useProjectDetailsStore } from "../../store/Hooks";
import { ReportStore } from "./ReportStore";

export const useReportStore = (): Instance<typeof ReportStore> => {
  return useProjectDetailsStore().reportStore;
};
